var _module_exports = "<div class=\"objblock objtitleblock\">\n  <span class=\"objtoptitle\">{{title()}}</span>\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/objectmanager/objecttitle.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;